import styled, { keyframes } from 'styled-components';

const iconEnterKeyframes = keyframes`
	0% {
		transform: translate(-50%, -200%);
		left: 50%;
		opacity: 0;
	}
	50% {
		transform: translate(-50%, 0);
		left: 50%;
		opacity: 1;
	}
	100% {
		transform: translate(0, 0);
		left: 0;
		opacity: 1;
	}
`;

const timeEnterKeyframes = keyframes`
	0% {
		opacity: 0;
		transform: translateX(-10px);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
`;

const exitKeyframes = keyframes`
	0% {
		transform: translateY(0);
		opacity: 1;
	}
	100% {
		transform: translateY(-200%);
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	column-gap: 10px;
	transition: transform 0.3s ease;

	&.timer-enter-active,
	&.timer-enter-done {
		.icon {
			animation-name: ${iconEnterKeyframes};
			animation-duration: 0.5s;
			animation-timing-function: ease;
			animation-iteration-count: 1;
			animation-direction: normal;
			animation-fill-mode: forwards;
		}

		.time {
			animation-name: ${timeEnterKeyframes};
			animation-duration: 0.75s;
			animation-timing-function: ease;
			animation-iteration-count: 1;
			animation-direction: normal;
			animation-delay: 0.5s;
			animation-fill-mode: forwards;
		}
	}

	&.timer-exit-active {
		.icon,
		.time {
			animation-name: ${exitKeyframes};
			animation-duration: 0.5s;
			animation-timing-function: ease;
			animation-iteration-count: 1;
		}
	}
`;

const StyledIconContainer = styled.div.attrs({ className: 'icon' })<{
	$icon: { color: string; icon: string | undefined; invert?: boolean };
}>`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	background-color: ${(props) => props.$icon.color};
	border-radius: 10px;
	transform: translateY(-200%);
	opacity: 0;
`;

const StyledTimeContainer = styled.div.attrs({ className: 'time' })`
	display: flex;
	align-items: center;
	column-gap: 10px;
	height: 30px;
	padding: 0 8px;
	border-radius: 10px;
	background-color: #ffffff;
	opacity: 0;
	transform: translateX(-100%);
`;

const StyledTimerText = styled.label`
	min-width: 40px;
	color: #262628;
	text-align: center;
	font-family: GT Walsheim Pro;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
`;

export {
	StyledIconContainer,
	StyledTimeContainer,
	StyledTimerText,
	StyledContainer,
};
